import styled, { css } from 'styled-components';

interface CellItemProps {
  backgroundColor: string;
  color: string;
  fontWeight?: string | number;
}

interface ValueAreaProps {
  textAlign: string;
  fontSize?: number | string;
  backgroundColor?: string;
}

export const CellItem = styled.div<CellItemProps>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  align-self: center;
  ${({ color, backgroundColor, fontWeight }) => css`
    color: ${color};
    background-color: ${backgroundColor};
    font-weight: ${fontWeight};
  `};
`;
export const ValueArea = styled.div<ValueAreaProps>`
  flex: 1;
  width: 0;
  margin: 0 5px;
  text-align: ${({ textAlign }) => textAlign};
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
  font-size: ${({ fontSize }) => fontSize || 10};
`;

export const ToolTip = styled.div`
  background-color: #333333;
  color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 13px;
`;
